import { render, staticRenderFns } from "./gl-icon.vue?vue&type=template&id=c3327e3a&"
import script from "./gl-icon.vue?vue&type=script&lang=js&"
export * from "./gl-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports